import { useEffect, useState } from "react";
import { Camera } from "lucide-react";

interface FloatingParticlesProps {
  count?: number;
}

interface Particle {
  id: number;
  left: string;
  top: string;
  delay: number;
  duration: number;
  opacity: number;
}

export const FloatingParticles = ({ count = 6 }: FloatingParticlesProps) => {
  // Positions use Math.random(); generate them only after mount so the
  // server-rendered HTML matches the first client render (no hydration mismatch).
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    setParticles(
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        delay: Math.random() * 3,
        duration: 8 + Math.random() * 4,
        opacity: 0.1 + Math.random() * 0.2,
      }))
    );
  }, [count]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute"
          style={{
            left: particle.left,
            top: particle.top,
            animation: `float ${particle.duration}s ease-in-out infinite`,
            animationDelay: `${particle.delay}s`,
            opacity: particle.opacity,
            willChange: 'transform'
          }}
        >
          <Camera className="w-8 h-8 text-primary" />
        </div>
      ))}
    </div>
  );
};
